const TransactionRuleComponent = () => {
  return (
    <>
      <h2>特定商取引法に基づく表記</h2>

      <div className="content-wrapper">
        <dl className="two-column-content">
          <dt>番組名</dt>
          <dd>あんず</dd>

          <dt>社名</dt>
          <dd>株式会社リアズ</dd>

          <dt>所在地</dt>
          <dd>大阪市淀川区西中島5-14-10新大阪トヨタビル4階</dd>

          <dt>サイト責任者</dt>
          <dd>釜野智史</dd>

          <dt>電話番号</dt>
          <dd>06-6307-2223</dd>

          <dt>お問合せ先</dt>
          <dd>お問い合わせ(9時～18時)</dd>

          <dt>支払方法</dt>
          <dd>
          お支払方法は、以下のいずれかよりお選びいただけます<br/>
          ・Googleplay決済
          </dd>

          <dt>事業内容</dt>
          <dd>
            インターネットを介したコミュニケーションサービスの提供及び運営
          </dd>

          <dt>ポイント単価</dt>
          <dd>1円=0.75pts</dd>

          <dt>返金について</dt>
          <dd>
            ライブコミュニケーションの提供というコンテンツの都合上､購入されたポイントについては一切返金できませんのであらかじめご了承くださいませ｡
          </dd>
        </dl>
      </div>
    </>
  );
};

export default TransactionRuleComponent;
